import { Button } from '@/components/common/button';
import { LoadingLayout } from '@/components/layout/loading-layout';
import Modal from '@/components/modal';
import { TextField } from '@/components/text-field';
import { useContactData, useContactModalData } from './state/hooks';

export const ContactPage = () => {
  const { setModalClosed } = useContactModalData();
  const {
    firstName,
    lastName,
    email,
    description,
    error,
    isLoading,
    setFirstName,
    setLastName,
    setEmail,
    setDescription,
    contact
  } = useContactData();

  return (
    <Modal.Frame
      classes="w-[95%] sm:w-2/3 md:w-3/5 xl:w-2/5 h-fit flex flex-col animate-slide-bottom-fast"
      closeOnClickOutside
      closeOnEsc
      color="dark"
      id="contact-modal"
      onClose={setModalClosed}
      open
      backdrop={true}
      variant="rounded"
    >
      <LoadingLayout loading={isLoading} overlay message="Submitting your details">
        <Modal.Header size="xs" title="Stay tuned" />

        <Modal.Body classes="flex flex-col gap-5 px-5 sm:px-10" size="md">
          <p className="text-sm text-left text-mountain-mist font-sans font-light leading-relaxed tracking-normal">
            Coming soon. Subscribe and be one of the first to join a creative & collaborative
            economy.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <TextField
              color="dark"
              error={Boolean(error.firstName)}
              helperText={error.firstName}
              id="contact-first-name"
              label="First name"
              onChange={setFirstName}
              variant="outlined"
              value={firstName}
              size="sm"
            />

            <TextField
              color="dark"
              error={Boolean(error.lastName)}
              helperText={error.lastName}
              id="contact-last-name"
              label="Last name"
              onChange={setLastName}
              variant="outlined"
              value={lastName}
              size="sm"
            />
          </div>

          <div className="w-full">
            <TextField
              color="dark"
              error={Boolean(error.email)}
              helperText={error.email}
              id="contact-email"
              label="Email"
              onChange={setEmail}
              variant="outlined"
              value={email}
              size="sm"
            />
          </div>

          <div className="w-full">
            <TextField
              color="dark"
              error={Boolean(error.description)}
              helperText={error.description || 'Optional'}
              id="contact-description"
              label="Description"
              maxLength={500}
              onChange={setDescription}
              placeholder="Tell us about your interest"
              rows={3}
              type="textarea"
              variant="outlined"
              value={description}
              size="sm"
            />
          </div>
        </Modal.Body>

        <Modal.Footer classes="flex gap-1">
          <Button classes="w-fit" size="sm" text="Cancel" onClick={setModalClosed} variant="text" />

          <Button classes="w-fit" size="sm" text="Submit" onClick={contact} />
        </Modal.Footer>
      </LoadingLayout>
    </Modal.Frame>
  );
};
